<template>
<figure class="m-0">
    <!-- Generator: Adobe Illustrator 24.0.3, SVG Export Plug-In . SVG Version: 6.00 Build 0)  -->
    <svg ref="svg" version="1.1" id="Layer_1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" x="0px" y="0px"
        viewBox="0 0 410 216" style="enable-background:new 0 0 410 216;" xml:space="preserve">
        <rect x="0.6" y="1" class="field-bg" width="409" height="214"/>
        <g>
            <path class="field-lines" d="M409.6,1H0.6v214h120.5v0.3h2V215h165v0.3h2V215h119.5V1z M2.6,213V3h118.5v210H2.6z M123.1,213V3h165v210
                H123.1z M407.6,213H290.1V3h117.5V213z"/>
            <circle class="field-bg" cx="202.6" cy="108" r="33"/>
            <path class="field-lines" d="M202.6,141c-18.2,0-33-14.8-33-33s14.8-33,33-33s33,14.8,33,33S220.8,141,202.6,141z M202.6,77
                c-17.1,0-31,13.9-31,31s13.9,31,31,31s31-13.9,31-31S219.7,77,202.6,77z"/>
            <rect x="202" y="95" class="field-lines" width="2" height="26.1"/>
            <path class="field-bg" d="M32.6,153v-31.9l0,0c1.7,0,3.5-0.3,5.1-1c1.5-0.6,3-1.5,4.2-2.7c1.2-1.1,2.1-2.5,2.8-4c1.4-3.1,1.4-6.7,0-9.8
                c-0.7-1.5-1.6-2.9-2.8-4c-1.2-1.2-2.6-2.1-4.1-2.7c-1.6-0.7-3.3-1-5.1-1V64c3.1,0,6.2,0.3,9.3,0.9c3,0.6,5.8,1.5,8.6,2.6
                c2.7,1.1,5.3,2.5,7.8,4.1c2.4,1.6,4.7,3.4,6.8,5.4s4,4.2,5.6,6.6c1.7,2.4,3.1,4.9,4.2,7.6c1.2,2.7,2.1,5.5,2.7,8.4
                c1.2,5.9,1.2,12,0,17.9c-0.6,2.9-1.5,5.7-2.7,8.4s-2.6,5.2-4.2,7.6c-1.7,2.4-3.5,4.6-5.6,6.6s-4.4,3.8-6.8,5.4
                c-2.5,1.6-5.1,3-7.8,4.1c-2.8,1.1-5.7,2-8.6,2.6C38.9,152.7,35.7,153,32.6,153z"/>
            <path class="field-lines" d="M77.7,99.1c-0.6-2.9-1.5-5.7-2.7-8.4c-1.2-2.6-2.6-5.2-4.2-7.6s-3.5-4.6-5.6-6.6s-4.4-3.8-6.8-5.4
                c-2.5-1.6-5.1-3-7.8-4.1c-2.8-1.1-5.7-2-8.6-2.6c-3-0.6-6.1-0.9-9.3-0.9v31.1c-6.7,0.7-12,6.5-12,13.4s5.3,12.7,12,13.4v31.1l0,0
                c3.1,0,6.2-0.3,9.3-0.9c3-0.6,5.9-1.5,8.6-2.6c2.7-1.1,5.4-2.5,7.8-4.1c2.4-1.6,4.7-3.4,6.8-5.4s4-4.2,5.6-6.6
                c1.7-2.4,3.1-4.9,4.2-7.6c1.2-2.7,2.1-5.5,2.7-8.4s0.9-5.9,0.9-9C78.6,105,78.3,102,77.7,99.1z M51.5,87.5l1.8-1.7
                c2.3,2.4,5,5.6,7.2,9.4L58,96.9l1.1,1.7l2.3-1.6c1.8,3.5,3.1,7.3,3.1,11.2H62v2h2.4c-0.4,3.4-1.5,6.5-3.1,9.3l-2.2-1.5l-1.1,1.7
                l2.3,1.5c-2.1,3.2-4.6,5.9-6.8,7.8l-2.1-1.9l-1.4,1.5l1.9,1.8c-1.1,0.9-2.1,1.6-2.6,2l-13.2-10.1c0.8-0.2,1.5-0.4,2.3-0.7
                c1.8-0.7,3.4-1.8,4.8-3.1c1.4-1.3,2.5-2.9,3.2-4.7c0.8-1.8,1.2-3.7,1.2-5.7s-0.4-3.9-1.2-5.7c-0.8-1.7-1.9-3.3-3.2-4.7
                c-1.4-1.3-3-2.4-4.8-3.1c-0.7-0.3-1.3-0.5-2-0.7l13-11.9c0.6,0.5,1.5,1.3,2.5,2.4L50.2,86L51.5,87.5z M22.6,108
                c0-6.3,5.2-11.5,11.5-11.5s11.5,5.2,11.5,11.5s-5.2,11.5-11.5,11.5S22.6,114.4,22.6,108z M75.7,116.6c-0.6,2.7-1.4,5.4-2.6,8
                c-1.1,2.5-2.5,4.9-4,7.2c-1.6,2.3-3.4,4.4-5.4,6.3c-2,1.9-4.2,3.7-6.5,5.2c-2.4,1.5-4.9,2.9-7.5,3.9c-2.7,1.1-5.4,1.9-8.3,2.5
                c-2.3,0.4-4.6,0.7-6.9,0.8v-12.4h3.2v-2h-3.2v-12.5l14.7,11.2l0.6-0.4c0.1-0.1,1.6-1,3.6-2.7l1.3,1.2l1.4-1.5l-1.1-1.1
                c0.9-0.8,1.9-1.8,2.8-2.8c1.6-1.7,3-3.5,4.1-5.3l1.6,1.1l1.1-1.7l-1.7-1.1c1.9-3.4,3.1-6.9,3.4-10.4h2.4v-2h-2.3
                c0-4.4-1.4-8.6-3.4-12.4l1.6-1L63.7,93l-1.4,1c-2.3-3.9-5.1-7.2-7.4-9.6l1.4-1.3l-1.4-1.5l-1.4,1.3c-1.9-1.8-3.2-3-3.4-3.1
                l-0.7-0.5L34.6,92.8V79.6h3.2v-2h-3.2v-12c2.3,0.1,4.6,0.4,6.9,0.8c2.8,0.6,5.6,1.4,8.3,2.5c2.6,1.1,5.1,2.4,7.5,3.9
                c2.3,1.5,4.5,3.3,6.5,5.2c2,1.9,3.8,4,5.4,6.3s2.9,4.7,4,7.2c1.1,2.6,2,5.2,2.6,8s0.9,5.7,0.9,8.6
                C76.6,110.9,76.3,113.8,75.7,116.6z"/>
            <path class="field-bg" d="M378.6,64v31.9l0,0c-1.7,0-3.5,0.3-5.1,1c-1.5,0.6-3,1.5-4.2,2.7c-1.2,1.1-2.1,2.5-2.8,4
                c-1.4,3.1-1.4,6.7,0,9.8c0.7,1.5,1.6,2.9,2.8,4c1.2,1.2,2.6,2.1,4.1,2.7c1.6,0.7,3.3,1,5.1,1V153c-3.1,0-6.2-0.3-9.3-0.9
                c-3-0.6-5.8-1.5-8.6-2.6c-2.7-1.1-5.3-2.5-7.8-4.1c-2.4-1.6-4.7-3.4-6.8-5.4c-2.1-2-4-4.2-5.6-6.6c-1.7-2.4-3.1-4.9-4.2-7.6
                c-1.2-2.7-2.1-5.5-2.7-8.4c-1.2-5.9-1.2-12,0-17.9c0.6-2.9,1.5-5.7,2.7-8.4c1.2-2.7,2.6-5.2,4.2-7.6c1.7-2.4,3.5-4.6,5.6-6.6
                s4.4-3.8,6.8-5.4c2.5-1.6,5.1-3,7.8-4.1c2.8-1.1,5.7-2,8.6-2.6C372.4,64.3,375.5,64,378.6,64z"/>
            <path class="field-lines" d="M390.6,108c0-6.9-5.3-12.7-12-13.4V63.5l0,0c-3.1,0-6.2,0.3-9.3,0.9c-3,0.6-5.9,1.5-8.6,2.6s-5.4,2.5-7.8,4.1
                s-4.7,3.4-6.8,5.4c-2.1,2-4,4.2-5.6,6.6c-1.7,2.4-3.1,4.9-4.2,7.6c-1.2,2.7-2.1,5.5-2.7,8.4s-0.9,5.9-0.9,9c0,3,0.3,6,0.9,9
                c0.6,2.9,1.5,5.7,2.7,8.4c1.2,2.6,2.6,5.2,4.2,7.6c1.6,2.4,3.5,4.6,5.6,6.6s4.4,3.8,6.8,5.4c2.5,1.6,5.1,3,7.8,4.1
                c2.8,1.1,5.7,2,8.6,2.6c3,0.6,6.1,0.9,9.3,0.9v-31.1C385.4,120.7,390.6,115,390.6,108z M359.7,128.6l-1.8,1.7
                c-2.3-2.4-5-5.6-7.2-9.4l2.5-1.6l-1.1-1.7l-2.3,1.6c-1.8-3.5-3.1-7.3-3.1-11.2h2.5v-2h-2.4c0.4-3.4,1.5-6.5,3.1-9.3l2.2,1.5
                l1.1-1.7l-2.3-1.5c2.1-3.2,4.6-5.9,6.8-7.8l2.1,1.9l1.4-1.5l-1.9-1.8c1.1-0.9,2.1-1.6,2.6-2l13.2,10.1c-0.8,0.2-1.5,0.4-2.3,0.7
                c-1.8,0.7-3.4,1.8-4.8,3.1c-1.4,1.3-2.5,2.9-3.2,4.7c-0.8,1.8-1.2,3.7-1.2,5.7s0.4,3.9,1.2,5.7c0.8,1.7,1.9,3.3,3.2,4.7
                c1.4,1.3,3,2.4,4.8,3.1c0.7,0.3,1.3,0.5,2,0.7l-13,11.9c-0.6-0.5-1.5-1.3-2.5-2.4l1.8-1.7L359.7,128.6z M369.8,149.7
                c-2.8-0.6-5.6-1.4-8.3-2.5c-2.6-1.1-5.1-2.4-7.5-3.9c-2.3-1.5-4.5-3.3-6.5-5.2s-3.8-4-5.4-6.3s-2.9-4.7-4-7.2c-1.1-2.6-2-5.2-2.6-8
                s-0.9-5.7-0.9-8.6s0.3-5.8,0.9-8.6c0.6-2.7,1.4-5.4,2.6-8c1.1-2.5,2.5-4.9,4-7.2c1.6-2.3,3.4-4.4,5.4-6.3s4.2-3.7,6.5-5.2
                c2.4-1.5,4.9-2.9,7.5-3.9c2.7-1.1,5.4-1.9,8.3-2.5c2.3-0.4,4.6-0.7,6.9-0.8V78h-3.2v2h3.2v12.5L362,81.3l-0.6,0.4
                c-0.1,0.1-1.6,1-3.6,2.7l-1.3-1.2l-1.4,1.5l1.1,1.1c-0.9,0.8-1.9,1.8-2.8,2.8c-1.6,1.7-3,3.5-4.1,5.3l-1.6-1.1l-1.1,1.7l1.7,1.1
                c-1.9,3.4-3.1,6.9-3.4,10.4h-2.4v2h2.3c0,4.4,1.4,8.6,3.4,12.4l-1.6,1l1.1,1.7l1.4-1c2.3,3.9,5.1,7.2,7.4,9.6l-1.4,1.3l1.4,1.5
                l1.4-1.3c1.9,1.8,3.2,3,3.4,3.1l0.7,0.5l14.7-13.5v13.2h-3.2v2h3.2v12C374.3,150.4,372,150.1,369.8,149.7z M377.1,119.5
                c-6.3,0-11.5-5.2-11.5-11.5s5.2-11.5,11.5-11.5s11.5,5.2,11.5,11.5S383.5,119.5,377.1,119.5z"/>
        </g>
        <g>
            <g class="player-position goalie">
                <g class="position">
                    <circle id="Ellipse_822_2_" class="position" cx="34.1" cy="108" r="7.5"/>
                    <path class="position" d="M48.1,104.1c-1.6,0-2.6,1.2-2.6,3.3c0,2.1,1,3.3,2.6,3.3c1.4,0,2.3-0.8,2.3-2.1h-2.2V107h4.3v1.3
                        c0,2.7-1.8,4.3-4.4,4.3c-2.9,0-4.8-2-4.8-5.2c0-3.3,2.1-5.2,4.8-5.2c2.3,0,4.1,1.4,4.4,3.4h-2.2C50,104.7,49.2,104.1,48.1,104.1z"
                        />
                </g>
            </g>
        </g>
        <g>
            <g class="player-position defense">
                <g class="position">
                    <circle id="Ellipse_824_1_" class="position" cx="122.1" cy="43" r="7.5"/>
                    <path class="position" d="M132.5,48.1V38h3.6c3.1,0,5,1.9,5,5.1c0,3.2-1.9,5.1-5,5.1L132.5,48.1L132.5,48.1z M136,46.3
                        c1.9,0,2.9-1,2.9-3.3s-1-3.2-2.9-3.2h-1.4v6.5H136z"/>
                </g>
                <g class="position">
                    <circle id="Ellipse_821_1_" class="position" cx="122.1" cy="108" r="7.5"/>
                    <path class="position" d="M132.5,113.1V103h3.6c3.1,0,5,1.9,5,5.1s-1.9,5.1-5,5.1L132.5,113.1L132.5,113.1z M136,111.3
                        c1.9,0,2.9-1,2.9-3.3s-1-3.2-2.9-3.2h-1.4v6.5H136z"/>
                </g>
                <g class="position">
                    <circle id="Ellipse_828_1_" class="position" cx="122.1" cy="173" r="7.5"/>
                    <path class="position" d="M132.5,178.1V168h3.6c3.1,0,5,1.9,5,5.1c0,3.2-1.9,5.1-5,5.1h-3.6V178.1z M136,176.3c1.9,0,2.9-1,2.9-3.3
                        s-1-3.2-2.9-3.2h-1.4v6.5H136z"/>
                </g>
            </g>
        </g>
        <g class="player-position midfield">
            <g class="position">
                <path class="position" d="M216.1,38l2.8,6.8h0.1l2.8-6.8h2.7v10.2h-2.1v-6.6h-0.1l-2.6,6.6h-1.4l-2.6-6.6h-0.1v6.7h-2.1V38H216.1z"/>
                <circle id="Ellipse_824_2_" class="position" cx="203.1" cy="43" r="7.5"/>
            </g>
            <g class="position">
                <path class="position" d="M216.1,167.9l2.8,6.8h0.1l2.8-6.8h2.7v10.2h-2.1v-6.6h-0.1l-2.6,6.6h-1.4l-2.6-6.6h-0.1v6.7h-2.1v-10.3H216.1z
                    "/>
                <circle id="Ellipse_828_2_" class="position" cx="203.1" cy="173" r="7.5"/>
            </g>
        </g>
        <g class="player-position draw-specialist">
            <circle id="Ellipse_821_2_" class="position" cx="203.1" cy="108" r="7.5"/>
            <g>
                <path class="position" d="M213.5,113.1v-10.2h3.6c3.1,0,5,1.9,5,5.1c0,3.2-1.9,5.1-5,5.1H213.5z M217,111.2c1.9,0,2.9-1,2.9-3.3
                    c0-2.3-1-3.2-2.9-3.2h-1.4v6.5H217z"/>
                <path class="position" d="M227.5,104.5c-1.1,0-1.6,0.5-1.6,1.1c0,0.7,0.7,1.1,1.6,1.3l0.9,0.2c1.8,0.4,3,1.3,3.1,3c0,1.9-1.5,3.1-4,3.1
                    c-2.5,0-4-1.1-4.1-3.3h2.1c0.1,1,0.9,1.5,2,1.5c1.1,0,1.8-0.5,1.8-1.3c0-0.7-0.6-1-1.7-1.3l-1.1-0.3c-1.7-0.4-2.8-1.3-2.8-2.8
                    c0-1.9,1.6-3.1,3.9-3.1c2.3,0,3.8,1.3,3.8,3.1h-2.1C229.1,105,228.5,104.5,227.5,104.5z"/>
                <path class="position" d="M234,114.6h-1.8l3.3-12.2h1.8L234,114.6z"/>
                <path class="position" d="M245.1,106.4c-0.2-1.1-1-1.8-2.2-1.8c-1.6,0-2.6,1.2-2.6,3.3c0,2.2,1,3.3,2.6,3.3c1.1,0,2-0.6,2.2-1.7l2.2,0
                    c-0.2,1.9-1.8,3.6-4.4,3.6c-2.7,0-4.7-1.9-4.7-5.2c0-3.3,2.1-5.2,4.7-5.2c2.4,0,4.1,1.4,4.4,3.7H245.1z"/>
            </g>
        </g>
        <g class="player-position attack">
            <g class="position">
                <path class="position" d="M298.9,48.1l3.5-10.2h2.8l3.5,10.2h-2.3l-0.8-2.3H302l-0.8,2.3H298.9z M305.1,44.1l-1.3-3.9h-0.1l-1.3,3.9
                    H305.1z"/>
                <circle id="Ellipse_824_3_" class="position" cx="289.1" cy="43" r="7.5"/>
            </g>
            <g class="position">
                <path class="position" d="M298.9,113.1l3.5-10.2h2.8l3.5,10.2h-2.3l-0.8-2.3H302l-0.8,2.3H298.9z M305.1,109.1l-1.3-3.9h-0.1l-1.3,3.9
                    H305.1z"/>
                <circle id="Ellipse_821_3_" class="position" cx="289.1" cy="108" r="7.5"/>
            </g>
            <g class="position">
                <path class="position" d="M298.9,178.1l3.5-10.2h2.8l3.5,10.2h-2.3l-0.8-2.3H302l-0.8,2.3H298.9z M305.1,174.1l-1.3-3.9h-0.1l-1.3,3.9
                    H305.1z"/>
                <circle id="Ellipse_828_3_" class="position" cx="289.1" cy="173" r="7.5"/>
            </g>
        </g>
    </svg>

</figure>

</template>

<script>
import positionsLogic from './AthletePositionsLogic';
export default {
    mixins: [ positionsLogic ]
}
</script>
